/*
transition.slideUpIn 效果

该文件包含两个指令

v-slide-up-in 该指令用于给父级 如 v-page 或者自定义父级添加, 用于确定具体哪个元素内的元素需要做动画

v-slide-up-in-stage 该指令用于给 v-slide-up-in 子级元素添加, 该指令接收一个 value:[false,Number],
类型为 false 或者为 number,
值为 false 时,意味着不执行动画
值为 number 时, 将会按照 number 从小到大排序依此执行动画
 */
import "./index.scss";

function slideUpIn(el) {
  //  1. El 通过 data-slide-up-in-stage-order 排序下
  let els = [];
  $(el)
    .find(".slide-up-in-stage")
    .map((index, el) =>
      els.push({
        el,
        order: parseInt(el.dataset.slideUpInStageOrder ?? 99999),
      })
    );

  els.sort((a, b) => a.order - b.order);

  $(els.map((item) => item.el)).velocity("transition.slideUpIn", {
    stagger: 250,
    complete() {
      $(els.map((item) => item.el))
        .removeClass("slide-up-in-stage")
        .css("transform", "");
    },
    delay: 600,
  });
}

export default {
  install(Vue) {
    Vue.directive("slideUpIn", {
      inserted: (el) => {
        el.classList.add("v-slide-up-in");

        setTimeout(() => slideUpIn(el), 300);
      },
    });

    Vue.directive("slideUpInStage", {
      inserted: (el, { value }) => {
        value = value ?? false;
        if (value === false) return;
        el.classList.add("slide-up-in-stage");
        el.dataset.slideUpInStageOrder = value;
      },
    });
  },
};
